import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import PhotographerCalendarComponent from '../../../photographerPersonalCalendar/PhotographerCalendarComponent';
import * as Site from '../../../../shared/Site';

const PhotographerFormComponentCalendar = (props: any) => {
    return (
        <fieldset>
            <legend>{Translate('photographer/modal/form/legend/calendar')}</legend>
            <PhotographerCalendarComponent
                onSave={props.updateCalendar}
                calendar={props.calendar}
                onChange={props.onCalendarChange}
                onCreated={props.onCreated}
                onUpdated={props.onUpdated}
                onDeleted={props.onDeleted}
                onRangeChanged={props.onRangeChanged}
                dontUseMinMaxTime={false}
                user={props.loggedInUser}
                photographerId={props.isEditMode ? props.user.id : undefined}
                canAddScandphotosWorkingHours={props.site !== Site.getSiteName(Site.Zentuvo)}
                isBookableOnScandphotos={props.user.isBookableScandphotos === true}
            />
        </fieldset>
    );
};

export default PhotographerFormComponentCalendar;
